import React, { useState } from "react";
import { Form, InputNumber, Typography , theme} from "antd";
import {
  alcoholOptions,
  educationalOptions,
  maritalStatusOptions,
  smokingOptions,
} from "../../../Options/historyOptions";
import DeselectableRadioGroup from "../../../../../blocks/FormItems/DeselectableRadioGroup";
import { hexToRgba } from "../../../../../helpers/utility";
const { Text } = Typography;

const PersonalHistory = ({ form }) => {
  const [refresh, setRefresh] = useState(false);
  const { token } = theme.useToken(); 
  const smoking = form.getFieldValue("smoking");
  return (
    <>
      <Text>Personal History</Text>
      <div className="subsection-card"
      style={{
                  borderLeft: `2px solid ${hexToRgba(token.colorPrimaryHover, 0.2)}`,
                  background: "transparent",
                  marginTop: "8px",
                }}
              >
        <DeselectableRadioGroup
          label="Marital Status"
          name="marital_status"
          options={maritalStatusOptions}
          form={form}
        />
        <DeselectableRadioGroup
          label="Education"
          name="education"
          options={educationalOptions}
          form={form}
        />
        <DeselectableRadioGroup
          label="Smoking"
          name="smoking"
          options={smokingOptions}
          form={form}
          setRefresh={setRefresh}
        />
        {smoking === "smoker" && (
          <Form.Item name={"smoking_since"}>
            <InputNumber
              addonAfter="yrs"
              placeholder="Smoking since no of years?"
              style={{ width: 250 }}
            />
          </Form.Item>
        )}
        {smoking === "stopped_smoking" && (
          <Form.Item name={"stopped_smoking_since"}>
            <InputNumber
              addonAfter="yrs"
              placeholder="Stopped since no of years?"
              style={{ width: 250 }}
            />
          </Form.Item>
        )}
        <DeselectableRadioGroup
          label="Alcohol"
          name="alcohol"
          options={alcoholOptions}
          form={form}
        />
      </div>
    </>
  );
};

export default PersonalHistory;
